import React, { memo, useMemo, useEffect } from 'react';
// import AppContainer from '@alife/superapp-app-center/dist/components/AppContainer';
import AppContainer from '@/components/AppContainer';
import appCenter from '@alife/superapp-app-center'
import { setSystemInfo, setRequiredHeaders } from '@alife/superapp-common-adapters'
import { useParams } from 'ice';
import { Loading } from '@alifd/next';
import store from '@/store';

const third_party: React.FC = () => {
  const [ currentSpace ] = store.useModel('spaceRole');
  const { bizCode } = useParams();
  
  useEffect(() => {
    if (currentSpace?.spaceId) {
      appCenter.setBasePath(`/superapp?spaceId=${currentSpace.spaceId}`)
      setRequiredHeaders({
        'x-space': currentSpace.spaceId,
      });
      setSystemInfo({
        spaceId: currentSpace.spaceId,
      });  
    }
  }, [currentSpace])

  const LoadingComponent = useMemo(() =>{
    return (props) => <Loading {...props} size="large"/>
  }, []);
  return (
    currentSpace?.spaceId && <AppContainer name={bizCode}  loading={LoadingComponent}/>
  );
};

export default memo(third_party);